import type { CatalogParams } from "@shared/components/CatalogSearch";
import type { ParamsOptions } from "@shared/hooks/useUrlParams";
import { useUrlParams } from "@shared/hooks/useUrlParams";

const useCatalogParams = (
  initialOptions?: ParamsOptions
): [CatalogParams, (params: CatalogParams, options?: ParamsOptions) => void] => {
  return useUrlParams<CatalogParams>(initialOptions);
};

export { useCatalogParams };
